'use client'

import type { User } from '@/lib/types'

interface UserHeaderProps {
  user?: User
  onClick?: VoidFunction
}

export const UserHeader = ({ onClick, user }: UserHeaderProps) => {
  if (!user) {
    return null
  }

  return (
    <button
      type="button"
      className="size-8 sm:size-10 rounded-full bg-brand flex items-center justify-center text-white text-sm font-medium uppercase"
      onClick={() => onClick?.()}
    >
      {user.email.slice(0, 2)}
    </button>
  )
}
